<!-- /**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */ -->
<template>
  <div>
    <v-row v-if="model && model.idPatient">
      <v-col cols="12" md="12" sm="12">
        <patient-information :model="model" />
      </v-col>
      <v-col cols="12" md="12" sm="12">
        <Patient-consultation-info :model="model" />
      </v-col>
    </v-row>
    <br />
    <v-row class="mt-2 mb-2">
      <v-expansion-panels v-model="panelSV" >
        <v-expansion-panel>
          <v-expansion-panel-header>
            <h3>Somatometría</h3>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-col cols="12" md="12" sm="12">
              <patient-somatometry :model="model" :suimFlag="suimFlag" />
            </v-col>
            <v-col cols="12" md="12" sm="12">
              <patient-antecedents
                :model="model"
                :isViewDetailsForm="isViewDetailsForm"
              />
            </v-col>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-divider></v-divider>
      <div class="separator20-50"></div>
    </v-row>
    <v-row dense>
      <v-col cols="12" md="12" sm="12" class="mb-5">
        <PersonalAntecedentsToOptometry
          :model="model"
          :isViewDetailsForm="isViewDetailsForm"
        />
      </v-col>
      <v-col cols="12" md="12" sm="12" class="mb-5">
        <ProceduresAndTable
          :model="model"
          :isViewDetailsForm="isViewDetailsForm"
          :toUpdateTable="toEdit"
        />
      </v-col>
      <v-col cols="12" md="12" sm="12" class="mb-5">
        <VisualAcuity
          :model="model"
          :listEyesInformation="listEyesInformation"
          :isViewDetailsForm="isViewDetailsForm"
        />
      </v-col>
      <v-col cols="12" md="12" sm="12" class="mb-5">
        <h3 align="left">Nota médica:</h3>
        <br />
        <v-row class="mb-5">
          <v-col
            @click.right.prevent
            @copy.prevent
            @paste.prevent
            ondrop="return false;"
          >
            <validation-provider
              v-slot="{ errors }"
              name="Nota médica"
              rules="required"
            >
              <vue-editor
                v-model="model.content"
                :errors-message="errors"
                required
                :disabled="isViewDetailsForm"
                @input="onEditorInput"
              />
              <span class="error--text">{{ errors.toString() }}</span>
            </validation-provider>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="12" sm="12">
        <PatientCIE10Component
          :model="model"
          :saveCie10Changes="saveCie10Changes"
          :isViewDetailsForm="isViewDetailsForm"
          :isUpdate="true"
        />
      </v-col>
      <v-col cols="12" md="12" sm="12">
        <GlassesNeed
          :model="model"
          :isViewDetailsForm="isViewDetailsForm"
          :clearGraduation="clearGraduation"
          :toUpdateTable="toEdit"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PatientInformation from "@/app/components/common/patient/PatientInformation.vue";
import PatientSomatometry from "@/app/components/common/patient/PatientSomatometry.vue";
import PatientCIE10Component from "@/app/components/common/patient/PatientCIE10Component.vue";
import PatientAntecedents from "@/app/components/common/patient/PatientAntecedents.vue";
import PatientConsultationInfo from "@/app/components/common/patient/PatientConsultationInfo.vue";
import VisualAcuity from "@/app/components/optometry/common/VisualAcuity.vue";
import PersonalAntecedentsToOptometry from "@/app/components/optometry/common/PersonalAntecedentsToOptometry.vue";
import ProceduresAndTable from "@/app/components/optometry/common/ProceduresAndTable.vue";
import GlassesNeed from "@/app/components/optometry/common/GlassesNeed.vue";
import { OptometryComponentService } from "@/app/services";
import { VueEditor } from "vue2-editor";
import { ValidationProvider, ValidationObserver } from "vee-validate";
export default {
  props: {
    model: Object,
    idMedicalPractice: String,
    saveCie10Changes: Boolean,
    isViewDetailsForm: Boolean,
    // updatetoModel: Boolean,
  },
  components: {
    PatientInformation,
    PatientSomatometry,
    PatientCIE10Component,
    PatientAntecedents,
    PatientConsultationInfo,
    VueEditor,
    ValidationProvider,
    ValidationObserver,
    VisualAcuity,
    PersonalAntecedentsToOptometry,
    ProceduresAndTable,
    GlassesNeed,
  },
  data() {
    return {
      dialogPDF: false,
      panelSV: 0,
      suimFlag: 1,
      listEyesInformation: [],
      optometryAttend: {},
      clearGraduation: {},
      toEdit: true,
    };
  },
  created() {
    this.listEye();
  },
  methods: {
    async listEye() {
      await OptometryComponentService.optometrySide()
        .then((res) => {
          res.data.map((eye) => {
            if (eye.numberParts == 1) {
              this.listEyesInformation.push(eye);
            }
          });
        })
        .finally(() => {
          this.setClearGraduation();
        });
    },
    onEditorInput(html) {
      const plain = html.replace(/<[^>]*>/g, '')
      if (!plain.trim()) {
        this.model.content = ''
      } else {
        this.model.content = html
      }
    },
    setClearGraduation() {
      let eyesAssigned = [];
      this.listEyesInformation.map((eye) => {
        let eyeassigned = {
          idGlassesGraduate: null,
          graduate: "",
          bodyPart: {
            idBodyPart: eye.idBodyPart,
            name: eye.name,
            acronym: eye.acronym,
            numberParts: eye.numberParts,
          },
        };
        eyesAssigned.push(eyeassigned);
      });
      let graduation = {
        dip: "",
        addition: "",
        typeGlasses: "",
        graduations: eyesAssigned,
      };
      this.clearGraduation = graduation;
    },
  },
};
</script>
